import { Box, Button, ButtonProps } from "@mui/material";
import { RetroButton } from "components/RetroButton";
import { Row } from "v2/components/base/Flex/ui";

const BaseButtonUI = (props: ButtonProps) => {
  return (
    <RetroButton size="md" variant="primary">
      {props.children}
    </RetroButton>
  );
};

export default BaseButtonUI;
